export default `float aoShade = clamp(aPacked.y, 0.0, 3.0) / 3.0;
vAO = mix(mix(0.46, 1.0, aoShade), 1.0, farFlat);
vFace = aPacked.x;
vScale = max(aPacked.z, 1.0);
vWorldPos = (modelMatrix * vec4(transformed, 1.0)).xyz;
#include <worldpos_vertex>`